/**
 * Модуль событий
 */

import { MyEvents } from "../shared/types";

export function emit(event: MyEvents) {

    var customEvent = new CustomEvent(event);
    document.dispatchEvent(customEvent);
}

export function on(e: MyEvents, fn: Function) {
    document.addEventListener(e, function (e) {
        fn();
    });
}